import styled from "styled-components";
import { StyledCheckbox } from "../StyledCheckbox";

export const SSearchFilters = styled.div`
	margin-top: 2rem;
`;

export const SSearchFilterGroup = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 1rem;
`;

export const SSearchFilterGroupOptions = styled.ul`
	list-style-type: none;
	display: flex;
	flex-direction: column;
	gap: 0.4rem;
	margin-top: 0.4rem;
`;

export const SSearchFilterGroupOptionLabel = styled.label`
	display: flex;
	align-items: center;
	gap: 0.6rem;
	line-height: 1.6rem;
	color: #000000;
	font-size: 1.2rem;
	cursor: pointer;
	input {
		margin: 0;
	}
`;

export const SCheckbox = styled(StyledCheckbox)``;
